import React from 'react'
import { IndexRoute, Route, Router } from 'react-router'
import window from 'global'
import Root from './containers/Root'
import Home from './containers/Home'
import Profile from './containers/Profile'
import ProfileProfile from './containers/ProfileProfile'
import ProfileSuggestions from './containers/ProfileSuggestions'
import ProfileFavorites from './containers/ProfileFavorites'
import ProfileInterests from './containers/ProfileInterests'
import ProfileAccount from './containers/ProfileAccount'
import ProfileRecommend from './containers/ProfileRecommend'
import CategoryDetail from './containers/CategoryDetail'
import CategoryDetailLP from './containers/CategoryDetailLP'
import OrganizationDetail from './containers/OrganizationDetail'

import OrganizationDetailFromDB from './containers/OrganizationDetailFromDB'

import OrganizationClaim from './containers/OrganizationClaim'
import UserInfo from './containers/UserInfo'
import ApplyToList from './containers/ApplyToList'
import BFWApplyToList from './containers/BFWApplyToList'
import AddResource from './containers/AddResource'
import Join from './containers/NewJoin'
import VerifyEmail from './containers/VerifyEmail'
import EmailVerification from './containers/EmailVerification'
import NotificationList from './containers/NotificationList'
import NotificationDetail from './containers/NotificationDetail'
import ForgotPassword from './containers/ForgotPassword';
import ForgotPasswordSent from './containers/ForgotPasswordSent';
import ResetPassword from './containers/ResetPassword'
import ResetPasswordResult from './containers/ResetPasswordResult'
import SearchResultList from './containers/SearchList'
import FlatPage from './containers/FlatPage'
import NotFound from './containers/NotFound'
import SurveyRedirect from './containers/SurveyRedirect'
import ApplyToListLP from './containers/ApplyToListLP'
import ApplyBuyFromWomenLP from './containers/ApplyBuyFromWomenLP'
import BuyFromWomenLP from './containers/BuyFromWomenLP'
import StoryDetail from './containers/StoryDetail'
import WhatWeDo from './containers/WhatWeDo'
import Festival from './containers/Festival'
import FestivalTickets from './containers/FestivalTickets'
import FestivalSponsorship from './containers/FestivalSponsorship'
import FestivalVolunteer from './containers/FestivalVolunteer'
import BFWOffers from './containers/BFWOffers'
import SharedStory from './containers/SharedStory'
import SharedStoryDetail from './containers/SharedStoryDetail'
import StoryArchive from './containers/StoryArchive'

import LeaderSpotlight from './containers/LeaderSpotlight'

import DirectoryLandingPage from './containers/DirectoryLandingPage'
import FestivalProgram from './containers/FestivalProgram'
import FestivalOurSponsors from './containers/FestivalOurSponsors'



import FestivalMap from './containers/FestivalMap'

import FestivalSchedule from './containers/FestivalSchedule'
import NewsletterDetail from './containers/NewsletterDetail'



export default (
    <Route component={Root}>
      <Route path="/" component={Home} />
      <Route path="/my" component={Profile}>
        <IndexRoute component={ProfileProfile} />

        <Route path="/my/suggestions" component={ProfileSuggestions} />

        <Route path="/my/favorites" component={ProfileFavorites} />
        <Route path="/my/interests" component={ProfileInterests} />
        <Route path="/my/account" component={ProfileAccount} />
        <Route path="/my/recommend" component={ProfileRecommend} />
      </Route>

      


      <Route path="/user/info" component={UserInfo} />
      <Route path="/user/emailverification" component={EmailVerification} />
      <Route path="/user/forgotpassword" component={ForgotPassword} />
      <Route path="/user/forgotpassword/sent" component={ForgotPasswordSent} />
      <Route path="/user/resetpassword/:uid/:token" component={ResetPassword} />
      <Route path="/user/resetpassword/:result" component={ResetPasswordResult} />
      <Route path="/user/emailverification/:cause" component={EmailVerification} />
      <Route path="/user/verifyemail/:verificationKey" component={VerifyEmail} />
      <Route path="/browse/:slug" component={CategoryDetailLP} />
      <Route path="/browse/:rootSlug/:slug" component={CategoryDetail} />
      <Route path="/browse/:rootSlug/:secondarySlug/:slug" component={CategoryDetail} />
      <Route path="/organizations/new" component={AddResource} />
      <Route path="/organizations/edit/:id" component={OrganizationDetail} />
      <Route path="/organizations/claim/:id" component={OrganizationClaim} />

      


      <Route path="/organizations/:id/:slug" component={OrganizationDetail} />

      <Route path="/featured-organization/:id/:slug" component={OrganizationDetailFromDB} />


      <Route path="/organizations/:id" component={OrganizationDetail} />


      


      <Route path="/notifications" component={NotificationList} />
      <Route path="/notifications/:id" component={NotificationDetail} />
      <Route path="/search" component={SearchResultList} />
      <Route path="/pages/*" component={FlatPage} />
      <Route path="/story/:id" component={StoryDetail} />
      <Route path="/shared-story" component={SharedStory} />
      <Route path="/shared-story-detail/:id" component={SharedStoryDetail} />

      <Route path="/leader-spotlight" component={LeaderSpotlight} />

      <Route path="/newsletter/:id" component={NewsletterDetail} />

      <Route path="/survey-redirect" component={SurveyRedirect} />
      <Route path="/apply-to-list" component={ApplyToList} />
      <Route path="/apply-to-list-lp" component={ApplyToListLP} />
      
      <Route path="/what-we-do" component={WhatWeDo} />
      <Route path="/buy-from-women-owned-businesses" component={BuyFromWomenLP} />
      <Route path="/bfw-apply-to-list" component={BFWApplyToList} />
      <Route path="/buy-from-women-offers" component={BFWOffers} />

      <Route path="/girls-festival" component={ () => {window.location = 'https://worldwidewomengirlsfestival.org/'; return null; }} />

      <Route path="/girls-festival/sponsorship" component={FestivalSponsorship} />
      <Route path="/girls-festival/volunteer" component={FestivalVolunteer} />
      <Route path="/girls-festival/program/:id/:slug" component={FestivalProgram} />
      <Route path="/girls-festival/program" component={FestivalProgram} />
      <Route path="/girls-festival/our-sponsors" component={FestivalOurSponsors} />

      <Route path="/girls-festival/map" component={FestivalMap} />

      <Route path="/girls-festival/tickets" component={FestivalTickets} />

      <Route path="/girls-festival/schedule" component={FestivalSchedule} />

      <Route path="/story-archive" component={StoryArchive} />


      <Route path="/global-resource-directory" component={DirectoryLandingPage} />

      

      <Route path='*' component={NotFound} />

    </Route>
);



// WEBPACK FOOTER //
// ./src/routes.js